import { defineStore } from 'pinia';
import { ref } from 'vue';
import { type ModifiedContactDetail, type ContactDetail } from '@shared/types/ContactDetail';
import ContactDetailsProcessor from '@/modules/profile-page/helpers/ContactDetailsProcessor';

export const useContactDetailsStore = defineStore('contactDetails', () => {
  const contactDetails = ref<ContactDetail[]>([]);
  const modifiedContactDetails = ref<ContactDetail[] | ModifiedContactDetail[]>([]);

  const processor = async () => await new ContactDetailsProcessor(modifiedContactDetails.value).process();

  return { contactDetails, modifiedContactDetails, processor };
});
